import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
const isV3 = allVue.version && allVue.version[0] === '3'
import KendoSwitchMixin from './KendoSwitchMixin'

export default {
    name: 'kendo-switch',
    mixins: [ KendoSwitchMixin ],
    setup() {
        const v3 = isV3
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        if(this.v3) {
            return h('input',{
                type: 'checkbox'
            })
        } else {
            return h('input',{
                attrs: {
                    type: 'checkbox'
                }
            })
        }
       
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoSwitch/index.js